module.exports = __webpack_public_path__ + "static/media/portfolio1 (60).edb0c504.jpeg";